<template>
  <div class="user-page">
    <div class="user-top">
      <div class="logobox">
        <van-row>
          <van-col span="4">
          <!--  <span class="iconfont" @click="leftshow = true">&#xe626;</span>-->
          </van-col>
          <van-col span="16" offset="0">
            <router-link to="/">
              <van-image :src="logoImg" />
            </router-link>
          </van-col>
          <van-col span="4" offset="0">
            <span class="iconfont" @click="goPath('/my/order.html')">&#xe636;</span>
          </van-col>
        </van-row>
      </div>
      <div class="userInfo">
        <div class="imgbox">
          <img :src="userInfo.picture" alt="">
        </div>
        <div class="right">
          <div class="rows userName">
            <h4>{{userInfo.nickname}} <span class="vip" v-if="userInfo.is_vip"></span><span class="author" v-if="userInfo.is_author"></span></h4>
          </div>
          <div class="rows">
            <p class="idbox">ID: <span>{{userInfo.unique_id}}</span></p>
          </div>
          <div class="rows ">
            <div class="iconfontBox">
              <!-- activ 选中状态 标签顺序（手机、微信、QQ、邮箱、微博）-->
              <span class="iconfont mobile" :class="userInfo.mobile  ? 'active':''">&#xe64f;</span>
              <span class="iconfont wx_oauth" :class="userInfo.wx_oauth ? 'active':''">&#xe63f;</span>
              <span class="iconfont qq_oauth" :class="userInfo.qq_oauth ? 'active':''">&#xe631;</span>
              <span class="iconfont email" :class="userInfo.email ? 'active':''">&#xe605;</span>
              <span class="iconfont wb_oauth" :class="userInfo.wb_oauth ? 'active':''">&#xe63d;</span>
            </div>
          </div>
        </div>
      </div>
      <div class="navbox">
      <!--  <a class="nav-link" :class="$route.path == '/' ? 'active':''" href="/conference/index"><span class="iconfont">&#xe61a;</span> <span class="text">首页</span></a>-->
        <router-link class="nav-link" :class="$route.path == '/myEnroll' ? 'active':''" to="/myEnroll"><span class="iconfont">&#xe66e;</span><span class="text">我的活动</span></router-link>
        <router-link class="nav-link" :class="$route.path == '/myOrder' ? 'active':''" to="/myOrder"><span class="iconfont">&#xe635;</span><span class="text">我的订单</span></router-link>
        <router-link class="nav-link" :class="$route.path == '/myInvoice' ? 'active':''" to="/myInvoice"><span class="iconfont">&#xe683;</span><span class="text">我的发票</span></router-link>
      </div>
    </div>
    <!-- 左侧导航条-->
    <van-popup v-model="leftshow" position="left" :style="{ width: '30%',height:'100%' }">
      <div class="leftLink">
        <ul>
          <li v-for="item in leftList">
            <a :href="item.link">{{item.text}}</a>
          </li>
        </ul>
      </div>
    </van-popup>
  </div>
</template>
<script>
  import {
    formatDates
  } from "../../assets/js/date"
  export default {
    data() {
      return {
        logoImg: require('@/assets/images/logo.png'),
        userInfo: {},
        leftshow:false,
        leftList:[
          {
            link:'/',
            text:'首页'
          },
          {
            link:'/book/bookstore.html',
            text:'电子书城'
          },
          {
            link:'/teaHouse/index.html',
            text:'先晓茶馆'
          },
          {
            link:'/column/index.html',
            text:'先晓专栏'
          },
          {
            link:'/brand/brandList.html',
            text:'学术品牌'
          },
          {
            link:'/author/list.html',
            text:'作者专区'
          },
        ],
      };
    },
    created() {
      var _this = this;
      _this.initPage();
      _this.$WXConfig.wxShowMenu({
        ifshare: true,
        that: _this,
        data: ''
      });

    },
    /* 时间过滤 */
    filters: {
      formatDates
    },
    methods: {
      goPath(path) {
        if (path == "") {
          return false;
        }
        // this.$router.push(path);
        window.location.href = path;
      },
      //初始化数据
      initPage() {
        var _this = this;
        let url = "/member/info";
        let params = {
          callbacktype: 'json'
        };
        _this.$get(url, params).then(res => {
          if (res.code == "1") {
            _this.userInfo = res.posts;
          }
        });
      },
    }
  };
</script>
<style lang="less">
  .user-page{
    //user 信息
    .user-top{
      width: 100%;
      .logobox{
        width: 100%;
        height: 80px;
        line-height: 80px;
        background: #FFF;
        padding: 20px 0px;
        box-shadow: 5px 5px 10px #999;
        border-bottom: 2px solid #ebebeb;
        .van-row{
          height: auto;
          .van-col{
            text-align: center;
            line-height: 40px;
            span{
              line-height: 40px;
              font-size: 40px;
            }
            img{
              height: 40px;
              line-height: 40px;
              width: auto;
            }
          }
        }
      }
      .userInfo{
        width:100%;
        overflow: hidden;
        background: #FFF;
        margin-bottom: 20px;
        padding: 30px;
        .imgbox {
          float: left;
          height: 140px;
          width: 140px;
          overflow: hidden;
          border-radius: 50%;
          margin-right: 30px;
          img {
            width: 100%;
            height: 100%;
            display: block;
          }
        }
        .right{

          .rows {
            overflow: hidden;
            > h4 {
              font-size: 30px;
              color: #4c4c4c;
              span {
                background-position: center;
                background-repeat: no-repeat;
                background-size: 100% 100%;
                display: inline-block;
                margin-left: 10px;
              }

              .vip {
                width: 28px;
                height: 32px;
                background-image: url(../../assets/images/icon/icon_vip.png);
              }

              .author {
                width: 80px;
                height:28px;
                background-image: url(../../assets/images/icon/icon_zuozhe.png);
              }
            }

            > span {
              font-size: 30px;
              color: #999;
              float: left;
            }

            > p {
              font-size: 26px;
              color: #999;
              margin: 10px 0px;
              width: 50%;
              float: left;
            }

            .iconfontBox {
              font-size: 30px;

              span {
                font-size: 30px;
                border-radius: 50%;
                overflow: hidden;
                width: 40px;
                height: 40px;
                display: block;
                float: left;
                background: #999;
                color: #FFF;
                text-align: center;
                line-height: 40px;
                margin-right: 10px;

                &.active {
                  &:nth-child(1) {
                    background: #0092ff;
                  }

                  &:nth-child(2) {
                    background: #00c29a;
                  }

                  &:nth-child(3) {
                    background: #0092ff;
                  }

                  &:nth-child(4) {
                    background: #ed6b00;
                  }

                  &:nth-child(5) {
                    background: #fe1818;
                  }
                }
              }
            }
          }

          .userName {
            font-size: 30px;
            color: #4c4c4c;
          }
        }
      }
      .navbox{
        background: #FFF;
        width: 100%;
        margin-bottom: 20px;
        padding: 20px 30px;
        overflow: hidden;
        .nav-link{
          width: 33.3%;
          float: left;
          display: block;
          overflow: hidden;
          span{
            display: block;
            width: 100%;
            text-align: center;
          }
          .iconfont{
            font-size: 50px;
            color: #999;
            height: 65px;
            line-height: 65px;
          }
          .text{
            font-size: 24px;
            color: #333;
          }
          &.active{
            .iconfont{
              color: #1994fb;
            }
            .text{
              color: #1994fb;
            }
          }
        }
      }
    }
    .leftLink{
      width: 100%;
      padding: 30px 0px;
      ul{
        width: 100%;
        li{
          line-height: 80px;
          text-align: center;
          font-size: 28px;
          a{
            display: block;
          }
        }
      }
    }
  }
</style>
